/**
 * Facets name in Algolia.
 */
export const FACETS = {
  AUDIENCE: 'audienceSegments',
  INTEREST: 'interestSegments',
  SEASON: 'seasonSegments',
}

/**
 * Params used for URL and window.segmentsData keys.
 */
export const PARAM_NAME = {
  [FACETS.AUDIENCE]: 'audience',
  [FACETS.INTEREST]: 'interest',
  [FACETS.SEASON]: 'season',
}

/**
 * Translation keys for select labels.
 */
export const LABELS = {
  [FACETS.AUDIENCE]: 'discover',
  [FACETS.INTEREST]: 'interested_in',
  [FACETS.SEASON]: 'in',
}

/**
 * Translation keys for select default values.
 */
export const DEFAULT_VALUE = {
  [FACETS.AUDIENCE]: 'all_audiences',
  [FACETS.INTEREST]: 'all',
  [FACETS.SEASON]: 'all_seasons',
}
